import Backbone from 'backbone'
import template from 'scoreboard/admin/connections/rest/rest-connection-wizard-view.hbs'
import i18n from 'scoreboard/components/i18n'
import {getWebServiceTypeTitle} from 'scoreboard/admin/connections/rest/ws-utils'
import constants from 'scoreboard/components/constants'
const {GET} = constants
import WsAuthenticationType from 'scoreboard/admin/model/ws-authentication-type'
const {BASIC_HTTP, OAUTH_V2} = WsAuthenticationType
import _ from 'lodash'
import $ from 'jquery'
import { VALIDATE_URL }
	from 'scoreboard/admin/model/import-connection-constants'
import handleOauthTokenEndpointException
	from 'scoreboard/admin/connections/rest/handle-oauth-token-endpoint-exception'

/**
 * Common view for all views used in {@link rest-connection-wizard.js}
 */
const RestConnectionWizardView = Backbone.View.extend({

	render: function() {
		RestConnectionWizardView.prototype.setTitle.apply(this, arguments)
		this.$el.html(template({ title: this.options.title }))
		this.options.wizard?.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
		this.formView.start()

		return this
	},

	setTitle: function() {
		const webServiceTypeTitle = getWebServiceTypeTitle(
			this.model?.attributes?.wsVendorType,
			i18n.get('admin.importConnections.web-service.rest'))
		const titleSuffix = i18n.get('admin.databaseConnections.connection')
		const addOrEditKey = this.model.isNew() ? 'common.add2': 'common.edit2'
		this.options.title = i18n.get(addOrEditKey, `${webServiceTypeTitle} ${titleSuffix}`)
	},

	getHttpRequestFormOptions: function(tokenOption) {
		const attrs = this.model.attributes
		const messageCodePrefix = 'admin.importConnections.web-service.oauthV2'
		const urlTitleMsgCode = `${messageCodePrefix}.${tokenOption}Endpoint`
		/**
		 * {@link ImportConnection.accessTokenHttpMethod} doesn't have the word "endpoint"
		 * which there probably is a reason for, so I'm keeping that pattern with
		 * {@link ImportConnection.refreshTokenHttpMethod}
		 */
		const httpMethod = attrs[`${tokenOption}HttpMethod`] || GET
		return {
			urlTitleMsgCode,
			url: attrs[`${tokenOption}Endpoint`],
			httpMethod,
			urlParameters: attrs[`${tokenOption}EndpointUrlParameters`],
			httpRequestHeaders: attrs[`${tokenOption}EndpointHttpHeaders`],
			requestBody: attrs[`${tokenOption}EndpointRequestBody`],
		}
	},

	saveHttpRequestFormState: function(tokenOption) {
		const attrs = this.model.attributes
		if (attrs.wsAuthenticationType !== OAUTH_V2) return

		const requestFormState = this.httpRequestForm.getState()
		attrs[`${tokenOption}Endpoint`] = requestFormState.url
		/**
		 * {@link ImportConnection.accessTokenHttpMethod} doesn't have the word "endpoint"
		 * which there probably is a reason for, so I'm keeping that pattern with
		 * {@link ImportConnection.refreshTokenHttpMethod}
		 */
		attrs[`${tokenOption}HttpMethod`] = requestFormState.httpMethod
		attrs[`${tokenOption}EndpointUrlParameters`] = requestFormState.urlParameters
		attrs[`${tokenOption}EndpointHttpHeaders`] = requestFormState.httpRequestHeaders
		attrs[`${tokenOption}EndpointRequestBody`] = requestFormState.requestBody
	},

	clearUnusedProperties: function() {
		const attrs = this.model.attributes

		// clear out the username and password so we don't store a hash of an empty string in the DB
		if (attrs.wsAuthenticationType !== BASIC_HTTP) {
			delete attrs.username
			delete attrs.password
		}

		// clear out all the oauth info if we're not actually using oauth
		if (attrs.wsAuthenticationType !== OAUTH_V2) {
			delete attrs.accessTokenEndpoint
			delete attrs.accessTokenHttpMethod
			delete attrs.accessTokenEndpointUrlParameters
			delete attrs.accessTokenEndpointHttpHeaders
			delete attrs.accessTokenEndpointRequestBody
		}

		// urlSuffix is only used for creating a DatasetConnection, not an ImportConnection
		delete attrs.urlSuffix
	},

	/**
	 * @param afterSaveStateFn {() => boolean} if this returns true, then we want to return
	 * after saving state and not do the actual "submit" action (usually an API call)
	 */
	submitAccessOrRefreshTokenView: function(afterSaveStateFn = _.identity) {
		this.saveState()

		if (afterSaveStateFn()) return

		RestConnectionWizardView.prototype.clearUnusedProperties.call(this)

		if (!this.shouldValidate()) {
			this.options.wizard.next()
			return
		}


		// for OAuth, we need to try to get a token to make sure the connection is valid
		$.post({
			url: VALIDATE_URL,
			data: JSON.stringify(this.model.attributes),
			success: importConnection => {
				_.extend(this.model.attributes, importConnection)
				this.options.wizard.next()
			},
			error: xhr => handleOauthTokenEndpointException.bind(this)(xhr)
		})
	},
})

/**
 * Analogous to {@link RemoteRestService#TokenOptions}
 * @type {{ACCESS_TOKEN: string, REFRESH_TOKEN: string}}
 */
const TOKEN_OPTIONS = {
	ACCESS_TOKEN: 'accessToken',
	REFRESH_TOKEN: 'refreshToken'
}

export default RestConnectionWizardView
export { TOKEN_OPTIONS }
RestConnectionWizardView.__filename__ = 'admin/connections/rest/rest-connection-wizard-view.js'
